const pl = {
  translation: {
    welcome: 'Witamy w',
    explore:
      'Odkryj NBAVerse z mapą klubów NBA, tabelami drużyn, wyszukiwarką graczy i statystykami na żywo.',
    getStarted: 'Zacznij',
    alreadyHaveAccount: 'Masz już konto?',
    login: 'Zaloguj się',
    mapPageTitle: 'Mapa',
    mapDescription:
      'Interaktywna mapa pokazuje lokalizacje klubów NBA, umożliwiając łatwą nawigację.',
    goToMap: 'Przejdź do mapy',
    mapImageAlt: 'Mapa Klubów NBA',

    search: 'szukaj',
    GameFinal: 'Koniec',
    home: 'główna',
    players: 'zawodnicy',
    map: 'mapa',
    teams: 'drużyny',
    teamPage: 'Drużyny',
    teamPageDescription:
      'Tutaj możesz wyszukać interesujące Cię drużyny NBA i dowiedzieć się o nich więcej.',
    previous: 'Poprzedni',
    next: 'Następny',
    goToTeams: 'Przejdź do Drużyn',
    PanelUser: 'Panel zarządzania użytkownikami',
    playersPage: 'Strona Graczy',
    playersPageDescription:
      'Użyj wyszukiwarki graczy, aby znaleźć szczegółowe informacje o swoich ulubionych graczy NBA.',
    seeMore: 'Zobacz więcej',
    finalStatus: 'Zakończone',
    games: 'mecze',
    team: 'Drużyna',
    city: 'Miasto',
    conference: 'Konferencja',
    division: 'Dywizja',
    nbaGames: 'Mecze NBA',
    allTeams: 'Wszystkie drużyny',
    loadingGames: 'Ładowanie meczów...',
    errorLoadingGames: 'Błąd podczas ładowania meczów',
    previousPage: 'Poprzednia strona',
    nextPage: 'Następna strona',
    vs: 'VS',
    CreateUser: 'stwórz nowego urzytkownika',
    soon: 'WKRÓTCE',
    delete: 'usuń',
    Edit: 'Edytuj',
    Edituser: 'Edytuj użytkownika',
    action: 'akcje',
    winner: 'Zwycięzca',
    filterByConference: 'Filtruj według konferencji',
    easternConference: 'Konferencja Wschodnia',
    westernConference: 'Konferencja Zachodnia',
    loadingTeams: 'Ładowanie drużyn...',
    email: 'E-mail',
    emailPlaceholder: 'Wprowadź swój e-mail',
    password: 'Hasło',
    passwordPlaceholder: 'Wprowadź swoje hasło',
    signInWithGithub: 'Zaloguj się przez Github',
    name: 'Imię',
    CreNewUser: 'Stwórz nowego użytkownika',
    cre: 'Stwórz',
    cancel: 'Anuluj',
    Role: 'Rola',
    namePlaceholder: 'Wprowadź swoje imię',
    confirmPassword: 'Potwierdź hasło',
    confirmPasswordPlaceholder: 'Potwierdź swoje hasło',
    register: 'Zarejestruj się',
    signUpWithGithub: 'Zarejestruj się przez Github',
    registrationSuccess: 'Rejestracja zakończona sukcesem!',
    registrationFailed: 'Rejestracja nie powiodła się',
    teamsList: 'lista drużyn',
    teamsTable: 'tabela drużyn',
    clearResults: 'Wyczyść wyniki',
    loginSuccess: 'Logowanie zakończone sukcesem!',
    loginFailed: 'Logowanie nieudane. Sprawdź swoje dane.',
    teamPageDescriptionSolo:
      'Poznaj historię drużyny oraz podstawowe informacje o jej mieście, konferencji i dywizji.',
    teamHistory: 'Historia Drużyny',
    noHistory: 'Brak historii dla tej drużyny.',
    logoutSuccessful: 'pomyślnie wylogowanao!',
    logout: 'wyloguj',
    footer: {
      title: 'NBAVerse.',
      description: 'Praca Inżynierska Piotr Fedak',
      copyright: 'Wszelkie prawa zastrzeżone',
      socialTitle: 'Media społecznościowe',
      linksTitle: 'Linki',
      home: 'Strona Główna',
      map: 'Mapa',
      teams: 'Drużyny',
      players: 'Gracze',
    },

    dontHaveAccount: 'Nie masz konta?',
    registerHere: 'Zarejestruj się tutaj',
    loginHere: 'Zaloguj się tutaj',

    auth: {
      loginNow: 'Zaloguj się teraz!',
      registerNow: 'Zarejestruj się teraz!',
      nbaverseAccount:
        'Zakładając konto na NBAVerse, możesz dodawać swoje ulubione zespoły i łatwo śledzić zmiany w NBA!',
      userReply: 'O naprawdę? Już zakładam konto!',
      chatTime: 'Czas',
      delivered: 'Dostarczono',
      seenAt: 'Widziano o',
    },
  },
};

export default pl;
